export default "__VITE_ASSET__BXd_p1D3__"